<template>
  <div class="home">
    <div class="home-bg"><img src="../assets/img/hbg.png" alt="" /></div>
    <div class="bg-mb"></div>
    <div class="home-header flex_between">
      <div class="company flex_center">
        <div class="logo"><img src="../assets/img/lg.png" alt="" /></div>
        <span>{{ $t("home.welcome") }}</span>
      </div>
      <div class="lang">
        <el-select
          @change="changeLang"
          class="autoWidth"
          v-model="lang"
          placeholder="Language"
        >
          <!-- el-select宽度下拉自适应 -->
          <template slot="prefix">
            {{ (langList.find((item) => item.value === lang) || {}).label }}
          </template>
          <el-option
            v-for="item in langList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="home-menu">
      <!-- :style="index>2?'opacity:0':''" -->
      <div
        @click="toPage(item.path)"
        v-show="item.show"
        class="item flex_column_align_center"
        v-for="(item, index) in menu"
        :key="index"
      >
        <div class="img flex_default_center">
          <img :src="item.icon" alt="" />
        </div>
        <p>{{ $t(item.title) }}</p>
        <span v-show="lang != 'en'">{{ item.txt }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { getNations, toBx } from "@/api/api";
import { setSession, getSession } from "@/util/localStor";
export default {
  data() {
    return {
      menuList: [],
      lang: "",
      langList: [
        {
          value: "zh",
          label: "中文",
        },
        {
          value: "en",
          label: "English",
        },
        {
          value: "ru",
          label: "Русский язык",
        },
        {
          value: "fa",
          label: "فارسی",
        },
        {
          value: "vi",
          label: "Tiếng Việt",
        },
        {
          value: "es",
          label: "español",
        },
      ],
      menu: [
        {
          title: "request.part",
          txt: "Vehicle Spare Parts",
          icon: require("../assets/img/11.png"),
          // path:'/index',
          path: 0,
          name: "carPart:get",
          show: false,
        },

        {
          title: "home.technologyCenter",
          txt: "Technical Center‌",
          icon: require("../assets/img/33.png"),
          // path: "/seek",
          path: 1,
          name: "technicalConsultation:get",
          show: false,
        },
        {
          title: "request.claimant",
          txt: "Claim Center",
          icon: require("../assets/img/44.png"),
          path: "/claimant/home",
          name: "claimCenter:get",
          show: false,
        },
        {
          title: "zlfk.title",
          txt: "Quality Feedback",
          icon: require("../assets/img/qualityFeedback.png"),
          path: "/qualityNew",
          name: "carQualityFeedback:get",
          show: false,
        },
        {
          title: "questionnaire.title",
          txt: "Questionnaire",
          icon: require("../assets/img/44.png"),
          path: "/questionnaire",
          name: "questionnaire:get",
          show: false,
        },
      ],
    };
  },
  // computed:{
  //     menu(){
  //         return  [
  //             {
  //                 title:this.$t('request.part'),
  //                 txt:'Vehicle spare parts',
  //                 icon:require('../assets/img/11.png'),
  //                 // path:'/index'
  //                 path:0,
  //                 name:'carPart:get',
  //                 show:false
  //             },
  //             // {
  //             //     title:this.$t('request.order'),
  //             //     txt:'Order Center',
  //             //     icon:require('../assets/img/22.png'),
  //             //     path:'/order'
  //             // },
  //             {
  //                 title:this.$t('home.productConsultation'),
  //                 txt:'Technical Consultation',
  //                 icon:require('../assets/img/33.png'),
  //                 path:'/seek',
  //                 name:'technicalConsultation:get',
  //                 show:false
  //             },
  //             {
  //                 title:this.$t('request.claimant'),
  //                 txt:'Claim Center',
  //                 icon:require('../assets/img/44.png'),
  //                 path:'/claimant',
  //                 name:'claimCenter:get',
  //                 show:false
  //             },
  //             // {
  //             //     title:this.$t('zlfk.title'),
  //             //     txt:'Quality feedback',
  //             //     icon:require('../assets/img/44.png'),
  //             //     path:'/quality'
  //             // },

  //             // {
  //             //     title:this.$t('home.userCenter'),
  //             //     txt:'User Center',
  //             //     icon:require('../assets/img/66.png'),
  //             //     path:'/center'
  //             // },

  //             // {
  //             //     title:this.$t('home.messageCenter'),
  //             //     txt:'Message Center',
  //             //     icon:require('../assets/img/55.png')
  //             // },
  //         ]

  //     }
  // },
  mounted() {
    if (sessionStorage.getItem("lang")) {
      this.$i18n.locale = sessionStorage.getItem("lang");
    }
    this.lang = this.$i18n.locale;
    this.getNationList();
    this.menuList = Object.values(getSession("menu"));
    this.getMenu();
  },
  methods: {
    getMenu() {
      this.menu.forEach((item1) => {
        this.menuList.map((item2) => {
          if (item1.name == item2) {
            item1.show = true;
          }
        });
      });
    },
    // 获取国家
    async getNationList() {
      const res = await getNations();
      if (res.status == 0) {
        setSession("nationList", res.data);
      }
    },
    changeLang() {
      this.$i18n.locale = this.lang;
      sessionStorage.setItem("lang", this.lang);
      //   console.log(this.menu)
    },
    toPage(path) {
      if (path == 0) {
        // 调用去百信的接口
        this.toBxPage();
      } else if (path == 1) {
        this.toBxPage("technical");
      } else {
        this.$router.push(path);
      }
    },
    async toBxPage(type) {
      let data = {
        appId: "44c2b961-3f99-4162-912b-cbbf1eff0d63",
        timestamp: "2023-08-07 12:12:12",
        sign: "167A8266DE1F3E8ABA602E02D2EBC3D9",
        account: getSession("person").customerAccountNum,
        loginSysType: type,
        // "account": '210008'
      };
      const res = await toBx(data);
      if (res.code == 10000) {
        window.open(res.data.url, "_self");
      } else {
        this.$DonMessage.error(`${this.$t("request.baned")}`);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/css/font.scss";
.home {
  overflow: hidden;
  height: 100vh !important;
  padding-top: 0px !important;
  background-color:  transparent;
  .home-bg {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: -2;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .bg-mb {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(4, 46, 100, 0.4);
    z-index: -1;
  }
  .home-header {
    width: 100%;
    box-sizing: border-box;
    padding: 20px 10px;
    .company {
      .logo {
        width: 24px;
        margin-right: 10px;
        img {
          width: 100%;
        }
      }
      span {
        font-size: 20px;
        font-family: $myfont;
        color: #fff;
        line-height: 20px;
      }
    }
    .lang {
      height: 36px;
      ::v-deep .el-input__inner {
        border-radius: 18px !important;
        background: rgba($color: #fff, $alpha: 0.8);
      }
      .autoWidth {
        min-width: 120px;
        text-align: start;
      }
      .autoWidth ::v-deep .el-input__prefix {
        position: relative;
        box-sizing: border-box;
        border: 1px solid #ffffff;
        padding: 0 30px;
        height: 36px;
        line-height: 36px;
        color: #202020;
        left: 0;
        visibility: hidden;
      }
      .autoWidth ::v-deep .el-input__inner {
        padding: 0 25px 0 12px !important;
        color: #202020;
        position: absolute; //这里一定需要给，给内容进行定位
      }
    }
  }
  .home-menu {
    height: calc(100% - 80px);
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    .item {
      cursor: pointer;
      .img {
        width: 90px;
        background: rgba($color: #fff, $alpha: 0.6);
        padding: 20px 10px;
        border-radius: 10px;
        -webkit-transform: perspective(1px) translateZ(0);
        transform: perspective(1px) translateZ(0);
        box-shadow: 0 0 1px rgba(0, 0, 0, 0);
        -webkit-transition-duration: 0.3s;
        transition-duration: 0.3s;
        -webkit-transition-property: transform;
        transition-property: transform;
        -webkit-transition-timing-function: ease-out;
        transition-timing-function: ease-out;

        img {
          width: 70px;
        }
      }
      .img:hover {
        background: rgba($color: #fff, $alpha: 0.7);
        box-shadow: rgba(0, 0, 0, 0.4) 0px 4px 6px 4px;
        -webkit-transform: translateY(-8px);
        transform: translateY(-8px);
      }
      p {
        margin: 20px 0 10px 0;
        font-family: $myfont;
        font-size: 20px;
        color: #fff;
        font-weight: bold;
      }
      span {
        font-size: 16px;
        font-family: $myfont;
        color: #fff;
      }
    }
  }
}
</style>
